import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Link, useLocation } from 'react-router-dom';
import { useApi } from '../api/contexts/ApiContext';
import { DataStructure } from '../types/type';

const Category: React.FC<{ onClose: any }> = ({ onClose }) => {
    const { userInfo } = useSelector((state: RootState) => state.auth);
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    const [data, setData] = useState<DataStructure>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const location = useLocation();
    const mode = new URLSearchParams(location.search).get('mode') == 'facility' ? 'facility' : 'company';

    const { getModule } = useApi();
    useEffect(() => {
        const fetchData = async () => {
            if (userInfo) {
                try {
                    const generalApi = await getModule('GeneralApi');
                    const response = await generalApi.getCountsForCategory({ user_id: userInfo.id, vendor_id: vendorInfo?.vendor_id ?? "" });
                    setData(response.data as DataStructure);
                } catch (error) {
                    console.error('Error:', error);
                }
            }
        };

        fetchData();
    }, []);

    const renderCategoryItem = (category: string, icon: string, companyCount: number, facilityCount: number, label: string) => (
        <div className="col-xl col-md-4 col-sm-6 mb-xl-0 mb-4">
            <Link onClick={onClose} to={`/search_result?category=${category}&mode=${mode}`} state={{ category }} style={{ textDecoration: "none" }}>
                <div className="bidding-condition-item-effect rounded border p-3 mb-1">
                    <div className={`bidding-condition-icon-bg ${icon}`}></div>
                    <p className="text-xs-2 text-center fw-400">{label}</p>
                </div>
            </Link>
            <div className="text-xs-2 fw-400 text-center">
                <span className="text-red-theme text-xs">{mode == 'facility' ? facilityCount : companyCount}</span>
                <span>{mode == 'facility' ? '施設' : '社'}</span>
                <span>{mode == 'facility' ? `(${companyCount}社)` : ''}</span>

            </div>
        </div>
    );

    return (
        <Modal.Body className="modal-content">
            <div className="modal-body">
                <section className="section p-0">
                    <div className="bg-red-theme height-40"></div>
                    <div className="p-4">
                        <div>
                            <span className="fw-400">応札期間中の案件：</span>
                            <span className="text-red-theme text-md fw-700 mr-3" id="all_count">
                                {mode == 'facility' ? data?.all_facility_count : data?.all_company_count}
                            </span>
                            <span className="fw-200" id="all_count_detail">{mode == 'facility' ? '施設' : '社'}</span>
                            <Link
                                onClick={onClose}
                                to={`/search_result?mode=${mode}`}
                                state={{ category: undefined }}
                                style={{ textDecoration: "none" }}
                            >
                                <span className="text-blue-deep-theme ml-4">全て表示する</span>
                            </Link>
                        </div>
                        <hr className="mt-1 mb-4" />
                        <div className="category-wrapper">
                            <div className="row">
                                {renderCategoryItem("recent", "icon-eye", data?.recently_viewed_company_count ?? 0, data?.recently_viewed_facility_count ?? 0, "最近閲覧した案件")}
                                {renderCategoryItem("new", "icon-new", data?.new_company_count ?? 0, data?.new_facility_count ?? 0, "新着")}
                                {renderCategoryItem("ending", "icon-exclamatory-sign", data?.ending_soon_company_count ?? 0, data?.ending_soon_facility_count ?? 0, "期限間近")}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Modal.Body>
    )
}

export default Category;